import { createContext, useContext, ReactNode, useState, useEffect } from 'react'
import { useLogAnalytics } from '../hooks/useLogAnalytics'
import { logAppOpenAnalytics } from '../firebase/analytics'

const AnalyticsContext = createContext(null)

interface FirebaseAnalyticsProviderProps {
	children: ReactNode
}

export const FirebaseAnalyticsProvider = ({ children }: FirebaseAnalyticsProviderProps) => {
	const analytics = useLogAnalytics()
	const [logAppOpen, setLogAppOpen] = useState(true)

	useEffect(() => {
		if (logAppOpen) {
			logAppOpenAnalytics()
			setLogAppOpen(false)
		}
	}, [logAppOpen])

	return <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>
}

export const useFirebaseAnalyticsContext = () => {
	const context = useContext(AnalyticsContext)
	if (!context) {
		throw new Error('useFirebaseAnalyticsContext must be used within AnalyticsProvider')
	}
	return context
}
